// getIsPrivateShowUnlocked.js
'use strict';
import createCachedSelector from '../resource/createCachedSelector.js';
import getStreamTokenDecodedData from '../selector/getStreamTokenDecodedData.js';
import getGoalData from '../selector/getGoalData.js';

/**
 * Select is private show unlocked by funding id
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @param {string} fundingId - funding id.
 * @param {string} meId - me id.
 * @return {null|boolean} Return true if me progress is more than 0. Return null if me progress is undefined.
 */
const getIsPrivateShowUnlocked = createCachedSelector(
  (state, streamId) => getStreamTokenDecodedData(state, streamId),
  (state, streamId, fundingId, meId) =>
    getGoalData(state, [fundingId, 'breakdown', meId], 'progress'),
  (streamToken, meProgress) => {
    return streamToken ? true : !!(meProgress && meProgress > 0);
  }
)((state, fundingId, meId) => `${fundingId}:${meId}`);

export default getIsPrivateShowUnlocked;
